import * as Yup from "yup";

export const BillabilityReportRecipientFormValidation = Yup.object({
    employeeId: Yup.string()
        .required("Employee is required"),
    weekly: Yup.boolean(),
    monthly: Yup.boolean()
        .test("at-least-one", "Pick weekly, monthly or both", function (monthly) {
            return monthly || this.parent.weekly;
        }),
});
